module.exports = "<span *ngIf=\"(control?.touched && control?.invalid) || condition\">\n  {{ errorMessage | translate }}\n</span>\n"